import { LCSW } from "../constants";

import { nameWithCredentials } from "./name-with-credentials";

export function supervisorSignature({
  credentials,
  name,
}: Omit<Parameters<typeof nameWithCredentials>[0], "credentialFallback">) {
  return nameWithCredentials({
    credentialFallback: LCSW,
    credentials,
    name,
  });
}
